export enum BookingType {
  Single = "single",
  Repeated = "repeated"
}
